"use strict";

Shopify.theme.jsCustomCookie = {
    init: function init($section) {
        Shopify.theme.jsCustomCookie = $.extend(this, Shopify.theme.getSectionData($section));
        this.$section = $section
        this.$steps = $section.find('.custom-cookie__step')
        this.previousStep = 1
        this.cookieType = ''
        this.cookieUrl = ''
        this.cookieId = ''
        
        this.initStep1()

    },
    initStep1: function initStep1() {
        let _self = this

        _self.currentStep = 1
        _self.$steps.hide()
        _self.handleNavigation()

        let $parent = _self.$section.find('.custom-cookie__step-1').show()
        let $input = $parent.find('[data-collection-selector]')
        
        $input.off('change')
      
        $input.off('click')

        _self.cookieType = $parent.find('[data-collection-selector]:checked').data('type')
        _self.cookieUrl = $parent.find('[data-collection-selector]:checked').data('url')
        _self.cookieId = $parent.find('[data-collection-selector]:checked').data('value')

        $input.on('change', function(e) {
            _self.cookieType = $(this).data('type')
            _self.cookieUrl = $(this).data('url')
            _self.cookieId = $(this).data('value')
        })

    },
    handleNavigation: function handleNavigation() {
        let _self = this
        _self.$section.find('[data-error]').addClass('is-hidden')

        let $parent = _self.$section.find('.custom-cookie__navigation')
        let $prev = $parent.find('[prev-step-button]')
        let $next = $parent.find('[next-step-button]')

        $prev.off('click')
        $next.off('click')

        if (_self.currentStep == 1) {
            $prev.attr('disabled', true).addClass('is-hidden')
            $next.attr('disabled', false).removeClass('is-hidden')
            $next.on('click', function(e) {
                _self.previousStep = 1
                Cookies.set('custom-cookie-form',{
                  'type':_self.cookieType,
                  'id':_self.cookieId
                })
                window.location.href = _self.cookieUrl
            })
        }
    },
    handleError: function handleError(error) {
        this.$section.find('[data-error]').removeClass('is-hidden').text(error)
    },
    unload: function unload($section) {}
};


//     renderProducts: function renderProducts($parent) {
//         let _self = this
//         let productSlider;

//         console.log('/collections/' + _self.selectedCollection)
//         $.ajax({
//             url: '/collections/' + _self.selectedCollection,
//             cache: false,
//             data: "view=".concat('custom_cookie'),
//             dataType: 'html',
//             headers: {
//                 'cache-control': 'no-cache'
//             },
//             success: function success(response) {
//                 $parent.html(response);
//                 $parent.find('.custom-cookie__products').removeClass('is-hidden')
//                 let data = JSON.parse($parent.find('[data-custom-data]').html())
//                 _self.totalProducts = data.total_products

//                 if (_self.totalProducts <= _self.productsPerRow) {
//                     return
//                 } else if (_self.totalProducts <= 50) {
//                     productSlider = $parent.find('.custom-cookie__products').flickity({
//                         cellAlign: 'left',
//                         wrapAround: false,
//                         pageDots: false
//                     })
//                 } else {
//                     Shopify.theme.infiniteScroll.enableInfinite(cb)

//                     function cb() {

//                         if (productSlider) {
//                             console.log('destroy')
//                             productSlider.flickity('destroy')
//                         }
//                         console.log('init')
//                         productSlider = $parent.find('.custom-cookie__products').flickity({
//                             cellAlign: 'left',
//                             wrapAround: false,
//                             pageDots: false
//                         })
//                     }
//                 }

//                 _self.handleProducts($parent)
//                 if (Shopify.theme_settings.show_multiple_currencies) {
//                     convertCurrencies();
//                 }
//             }
//         })

//     },
//     handleProducts: function handleProducts($parent) {
//         let _self = this

//         console.log('adding handler on products')
//         $(document).on('change', '[data-product-selector]', function() {
//             console.log('changed')
//             _self.selectedProducts = []
//             let $checked = $parent.find('[data-product-selector]:checked')
//             $checked.map(function(index, item) {
//                 _self.selectedProducts.push($(item).data('value'))
//             })
//             console.log(_self.selectedProducts)
//         })

//     },


//  function orderdate(){
//       var orderdate;
//     $.ajax({
//       url: 'https://c2-digitalapps.com/client_apps/cupcake-market-nyc/app/get_dates.php', 
//       type: 'GET',
//       dataType: 'json',
//       beforeSend: function(){
//         console.log('before');
//       },
//       success: function(php_script_response){
//         console.log(php_script_response); 
//         orderdate = php_script_response;
//       }
//     });
//  }


// orderdate();